<template>
  <div>
    <Dropzone
      ref-key="dropzoneRef"
      id="dropzoneRef"
      :options="{
        url: 'https://httpbin.org/post',
        paramName: 'file',
        thumbnailWidth: 150,
        acceptedFiles: 'image/*',
        maxFilesize: 1.05,
        addRemoveLinks: true,
        maxFiles: 1,
        headers: { 'My-Awesome-Header': 'header value' }
      }"
      class="dropzone mt-6"
    >
      <div class="text-lg font-medium">
        {{ i18n('slider.fileUploaderHint') }}
      </div>
    </Dropzone>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, provide } from 'vue'
import Dropzone from 'dropzone'
import { FileUploader } from '@/shared/uploader/file-uploader'

export default defineComponent({
  props: {
    id: String
  },
  setup(props, ctx) {
    let uploadLoading = ref(false)
    const dropzoneRef = ref()
    const filesToSave = ref([])
    provide('bind[dropzoneRef]', el => {
      dropzoneRef.value = el
    })
    const clearDropzone = () => {
      Dropzone.forElement('#dropzoneRef').removeAllFiles(true)
      while (filesToSave.value.length > 0) {
        filesToSave.value.pop()
      }
    }
    const getDropZoneInstance = () => {
      return dropzoneRef.value
    }
    const setupDropZone = () => {
      const elDropzoneRef = getDropZoneInstance()
      const path = `category/${props.id}/image`
      let flag = true
      elDropzoneRef.dropzone.on('addedfile', async (file) => {
        if (flag) {
          const uploadedFile = await FileUploader.upload(path, file, 'categoryImage')
          filesToSave.value.push(uploadedFile.publicUrl)
          ctx.emit('addedFile', uploadedFile.publicUrl)
          flag = false
        }
      })
      elDropzoneRef.dropzone.on('success', file => {
      })

      elDropzoneRef.dropzone.on('removedfile', async (file) => {
        await FileUploader.delete(path, file, 'categoryImage')
        filesToSave.value.pop()
      })

      elDropzoneRef.dropzone.on('complete', () => {
        uploadLoading = false
      })

      elDropzoneRef.dropzone.on('uploadprogress', () => {
        uploadLoading = true
      })
    }
    onMounted(() => {
      setupDropZone()
    })
    return {
      setupDropZone,
      uploadLoading,
      filesToSave,
      getDropZoneInstance,
      clearDropzone
    }
  },
  methods: {
    i18n(key, args) {
      return this.$t(key, args)
    }
  }
})
</script>
